import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Button,
  Paper,
  CircularProgress
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMember } from '../contexts/MemberContext';
import { ReactComponent as CinchLogo } from '../cinch.svg';
import CompanyLogo from '../components/CompanyLogo';
import DeviceService from '../services/deviceService';
import { useSnackbar } from '../contexts/SnackbarContext';
/**
 * Marketing Signup Page
 * Allows users to opt-in to marketing communications
 */
const MarketingSignupPage = () => {
  const [loading, setLoading] = useState(false);
  const { deviceInfo } = useAuth();
  const { member, setMember } = useMember();
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber, rawPhoneNumber } = location.state || {};
  const { showError } = useSnackbar();

  const handleAccept = async () => {
    setLoading(true);

    try {
      // Add member and store the response in the MemberContext
      const response = await DeviceService.addMemberByPhone(rawPhoneNumber);

      // Save the member data to context for use in the member dashboard
      setMember(response);

      // Navigate to the member dashboard
      navigate('/member-dashboard');
    } catch (error) {
      console.error('Error adding member:', error);
      showError('Failed to sign up for marketing communications. Please try again later.');
    }
    setLoading(false);
  };

  const handleDecline = () => {
    // Even if they decline marketing, take them to member dashboard
    navigate('/landing');
  };

  return (
    <Container maxWidth="md" sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      py: 4
    }}>
      {/* Company Logo at top center */}
      <Box display="flex" justifyContent="center" mt={2} mb={4}>
        <CompanyLogo />
      </Box>

      {/* Main content area */}
      <Box flexGrow={1} display="flex" flexDirection="column" justifyContent="center">
        <Typography variant="h4" component="h1" gutterBottom align="center" fontWeight="bold" mb={4}>
          Join Our Loyalty Program
        </Typography>

        <Typography variant="body1" paragraph align="center" mb={4}>
          Would you like to receive special offers, promotions, and updates from{' '}
          <strong>{deviceInfo?.company_name || 'our company'}</strong>?
        </Typography>

        <Typography variant="body1" paragraph align="center" mb={4}>
          <strong>{phoneNumber}</strong>
        </Typography>


        <Typography variant="body2" paragraph align="center" color="text.secondary" mb={4}>
          By accepting, you agree to receive marketing communications via SMS to {phoneNumber}.
          Message and data rates may apply. You can opt out at any time.
        </Typography>

        <Box display="flex" justifyContent="center" gap={3} mt={4}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={handleDecline}
            disabled={loading}
            sx={{ minWidth: '120px' }}
          >
            No Thanks
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleAccept}
            disabled={loading}
            sx={{ minWidth: '120px' }}
          >
            {loading ? <CircularProgress size={24} /> : 'Yes, Sign Me Up'}
          </Button>
        </Box>
      </Box>

      {/* Footer */}
      <Box pb={2} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body3" color="text.secondary">
          powered by
        </Typography>
        <Box ml={1} display="flex" alignItems="center">
          <CinchLogo
            width={75}
            style={{ marginRight: '4px' }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default MarketingSignupPage;